import React from "react";
import {
  Box,
  Heading,
  useColorMode,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Grid,
  Text,
  Flex,
} from "@chakra-ui/react";
import Translate from "../../components/LanguageTranslation/Translate";

const FAQBusinessPage = () => {
  const { colorMode } = useColorMode();

  return (
    <Box
      p={{ base: 8, md: 8, lg: 6, xl: 8 }}
      pl={{ base: 4, md: 8, lg: 40, xl: 80 }}
      pr={{ base: 4, md: 8, lg: 40, xl: 80 }}
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        alignItems="right"
        w="100%"
      >
        <Box flex="2">
          <Heading
            as="h2"
            size={{ base: "30px", md: "xl", lg: "xl" }}
            fontFamily="Poppins, sans-serif"
            mb={4}
            ml={{ base: "4", md: "6", lg: "6", xl: "24" }}
            textAlign={{ base: "left", md: "left", lg: "left", xl: "left" }}
          >
            <Translate text="FAQs" />
          </Heading>
        </Box>

        <Box
          flex="2"
          justify="flex-end"
          align="right"
          w={{ base: "100%", md: "50%", lg: "50%", xl: "50%" }}
          mr={{ base: "0", md: "0", lg: "0", xl: "20" }}
        >
          <Accordion
            allowToggle
            w={{ base: "100%", md: "100%", lg: "100%", xl: "80%" }}
            textAlign="left"
          >
            {/* 1. What is the Carbon Offset Program? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="What is the Carbon Offset Program?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="Our Carbon Offset Program allows users to calculate the environmental footprint of their trip and voluntarily offset it by contributing to certified nature and climate projects. This way, you actively contribute to preserving the planet you love to explore.
"
                />
              </AccordionPanel>
            </AccordionItem>

            {/* 2. Why is it important for travelers to offset their carbon footprint? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Why is it important for travelers to offset their Carbon footprint?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate text="Offsetting CO₂ emissions is essential because travel inevitably contributes to climate change, especially through transportation and accommodation. By offsetting your emissions, you help protect the nature you visit, support sustainable initiatives worldwide, and contribute to a future-proof travel industry. It's a concrete step toward responsible and conscious travel." />
              </AccordionPanel>
            </AccordionItem>

            {/* 3. How is my carbon footprint calculated? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="How is my Carbon footprint calculated?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="Our AI Travel Planner analyzes your planned travel details, such as transportation, accommodation, and trip duration. Based on this data, we provide an accurate estimate of your CO₂ emissions, using internationally recognized standards (including IPCC and ICAO methodologies).
"
                />
              </AccordionPanel>
            </AccordionItem>

            {/* 4. Where does my donation go? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Where does my contribution go?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text={`Your contribution directly supports the impactful project of your choice, such as: The Ocean Cleanup or Planet Impact Fund. We work with reliable and transparent international partners to ensure your contribution makes a real difference.
`}
                />
              </AccordionPanel>
            </AccordionItem>

            {/* 5. What is the ‘Proof of Impact’ certificate? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate
                    text="What is the ‘Proof of Impact’ certificate?
"
                  />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="As a thank-you for your contribution, you’ll receive a digital certificate (NFT) as tangible proof of your positive impact. This unique ‘Proof of Impact’ NFT is stored on the blockchain and can be shared on social media or kept as a personal keepsake.
"
                />
              </AccordionPanel>
            </AccordionItem>

            {/* 6. Why do you use NFTs? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Why do you use NFTs?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text={`NFT technology offers:
\n • Transparency: Your impact is publicly verifiable and tamper-proof.
\n • Ownership: The certificate is unique and truly yours.
\n • Awareness: By sharing it, you inspire others to contribute as well.
\n We use energy-efficient blockchain technology (Polygon) to avoid ecological drawbacks.
`}
                />
              </AccordionPanel>
            </AccordionItem>

            {/* 7. How much does it cost to offset my trip? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate
                    text="How much does it cost to offset my trip?
"
                  />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="The cost is based on your CO₂ emissions and starts from just a few euros. This includes a modest 3% administration fee to cover ongoing program management. You also have the option to contribute a fixed amount of your choice. For every ton of CO₂ you offset, you'll receive insights into the positive impact you’re making.
"
                />
              </AccordionPanel>
            </AccordionItem>

            {/* 8. Is my payment secure? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate
                    text="Is my payment secure?
"
                  />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="Yes. We use secure, encrypted payment methods (such as iDEAL and credit card) via trusted payment providers. Your data is never shared with third parties.
"
                />
              </AccordionPanel>
            </AccordionItem>

            {/* 9. How can I view or share my Proof of Impact certificate? */}
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="How can I view or share my Proof of Impact certificate?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate text="After contributing, you’ll receive an email with your NFT and a personal link. From there, you can download your certificate, add it to your crypto wallet, or easily share it on social media." />
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Flex>
    </Box>
  );
};

export default FAQBusinessPage;
